import { Card, CardHint, CardTitle } from './Card';
import { useT } from '../lib/i18n';

interface Props {
  message?: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

/**
 * Standard error-with-retry surface. Replaces the loose `<p className="text-destructive">{err.message}</p>`
 * scattered across list pages. Use as the entire content of an error branch.
 */
export function RetryCard({ message, onRetry, isRetrying }: Props): JSX.Element {
  const { t } = useT();
  return (
    <Card className="text-center">
      <CardTitle>{t('error.cantLoad.t')}</CardTitle>
      <CardHint>{message ?? t('error.cantLoad.b')}</CardHint>
      <button
        type="button"
        onClick={onRetry}
        disabled={isRetrying}
        className="mt-3 inline-flex min-h-[44px] items-center justify-center rounded-pill bg-brand-green px-4 py-2 text-sm font-semibold text-white transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-green focus-visible:outline-offset-2 disabled:opacity-50"
      >
        {isRetrying ? t('error.cantLoad.retrying') : t('error.cantLoad.retry')}
      </button>
    </Card>
  );
}
